/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

export const NAV_BAR_HEIGHT = 64;

const styles = {
  wrapper: css`
    position: fixed;
    top: ${NAV_BAR_HEIGHT}px;
    right: 0;
    left: 0;
    z-index: 2;
  `,
};

const StickyBanner: React.LegacyFunctionComponentWithChildren<{}> = ({ children }) => {
  return <div css={styles.wrapper}>{children}</div>;
};

export default StickyBanner;
